import type { FaireProductEntity } from "../../entity_types/product";

export const p_kqb8p48xju: FaireProductEntity = {
  token: "p_kqb8p48xju",
  type: "product",
  name: "Cold Brew Can",
  brandToken: "b_50b0t2xt",
  brandName: "Canyon Coffee",
  imageUrl:
    "https://cdn.faire.com/fastly/1d03a617e618b5fc47dde9d791bb0dcb9ae9286625e0c8a0d2f818a0ec6303bd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/752f41a43bd1eafa33441b88ca5a338d4388b0e9a48c49c145f8b6189f72885b.jpeg",
    "https://cdn.faire.com/fastly/ca7481015ae5c1bdc285bb0e4e069f94dd0e0c8adf165aea800fe9396915a2f6.jpeg",
  ],
  priceDollars: 3,
  description:
    "Canyon Cold Brew is here!\n\n• Roasted in LA,\n• Regenerative Organic Certified,\n• Expertly roasted and brewed,\n• Fully Recyclable,\n• Shelf Stable,\n• Ready-to-Drink\n• Cold Brew.\n\nAvailable exclusively for Canyon wholesale partners (not on Amazon, not through grocery distribution!).\n\nWe're so excited to introduce our first ready-to-drink coffee beverage. This product is one of the first cold brews to achieve the Regenerative Organic Certified (ROC) Bronze label, crafted from sustainably sourced beans produce by the ASPRASAR Cooperative in Tolima, Colombia.\n\nEnjoy the smooth, rich flavors of Canyon Coffee in a convenient, ethically produced package that stands out in quality and sustainability.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:08.928Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
